import { UseCase } from "../../base";
import { MasterlocationRepository } from "../../repositories";
import { Observable } from "rxjs";
import { PublicLocation } from "../../domain/models";
import { Injectable } from "@angular/core";
import { PublicLocationRequest } from "../../domain/requests";

@Injectable({ providedIn: 'root' })
export class GetPublicLocationsUsecase implements UseCase<PublicLocationRequest, PublicLocation[]> {
  constructor(private readonly masterlocationRepository : MasterlocationRepository) {
  }

  execute(request: PublicLocationRequest): Observable<PublicLocation[]> {
    return this.masterlocationRepository.getPublicLocations(request);
  }
}
